function trimSlashes(str) {
  return str.replace(/(?:^\/|\/$)/g, '')
}

export function join(...parts) {
  return '/' + parts.map(part => trimSlashes(part)).filter(present => present).join('/')
}

export { absoluteURL } from 'index'